import { projectRequest } from 'store/utils/request';

export const getDictionariesRequest = async params => {
  try {
    return await projectRequest.get(`/dictionaries/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export default getDictionariesRequest;
